import { cva } from '@/styled-system/css';

export const drawerContentRecipe = cva({
  base: {
    'backgroundColor': 'bg.elevated.mediumShadow',
    'display': 'flex',
    'flexDirection': 'column',
    'inlineSize': '100%',
    'minBlockSize': '0',
    'overflow': 'hidden',
    'position': 'relative',
    'transitionProperty': {
      _motionReduce: 'none',
      _motionSafe: 'transform, opacity',
    },
    'transitionDuration': {
      _motionReduce: '0s',
      _motionSafe: '{durations.250}, {durations.150}',
    },
    'transitionTimingFunction': '{easings.ease-out}',
    'zIndex': 2,

    '&:not(:has(.c11n_drawer__header))': {
      paddingBlockStart: 'layout.loosest',
    },
  },
  variants: {
    open: {
      true: {
        opacity: 1,
        transform: 'none',
      },
      false: {
        opacity: 0,
      },
    },
    placement: {
      bottom: {
        alignSelf: 'end',
        borderStartStartRadius: {
          base: 'obj.soft',
          md: 'none',
        },
        borderStartEndRadius: {
          base: 'obj.soft',
          md: 'none',
        },
        boxShadow: 'smHeavy',
        justifySelf: 'stretch',
        maxBlockSize: '100%',
      },
      left: {
        alignSelf: 'stretch',
        boxShadow: 'md',
        justifySelf: 'start',
        maxInlineSize: {
          base: 'none',
          md: '375px',
        },
      },
      right: {
        alignSelf: 'stretch',
        boxShadow: 'md',
        justifySelf: 'end',
        maxInlineSize: {
          base: 'none',
          md: '375px',
        },
      },
    },
  },
  compoundVariants: [
    { placement: 'bottom', open: false, css: { transform: 'translateY(50%)' } },
    { placement: 'left', open: false, css: { transform: 'translateX(-50%)' } },
    { placement: 'right', open: false, css: { transform: 'translateX(50%)' } },
  ],
});
